/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import { groupBy } from 'lodash';
import moment from 'moment';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { dispatchTableLoader } from '../../../../SharedModules/Table/store/Actions';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const contentFont = 10;
const pageMargins = [32, 100, 28.8, 25.92];
const styles = {
  header: {
    fontSize: 18,
    bold: true,
    margin: [0, 0, 0, 10],
  },
  subheader: {
    fontSize: 16,
    bold: true,
    margin: [0, 10, 0, 5],
  },
  tableExample: {
    margin: [0, 5, 0, 15],
  },
  tableHeader: {
    bold: true,
    fontSize: 13,
    color: 'black',
  },
};
//.toLocaleString('en-US', { minimumFractionDigits: 4 })
const valueFormatter = (value) => {
  if (value < 0) {
    return (
      '($' +
      value
        .toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        })
        .substring(2) +
      ')'
    );
  } else {
    return parseFloat(value).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }
};

const numberFormatter = (value, isUnit) => {
  if (isUnit) {
    if (value < 0) {
      return (
        '(' +
        value
          .toLocaleString('en-US', { minimumFractionDigits: 4 })
          .substring(1) +
        ')'
      );
    } else {
      return parseFloat(value)?.toLocaleString('en-US', {
        minimumFractionDigits: 4,
      });
    }
  } else {
    if (value < 0) {
      return (
        '(' + parseFloat(value)?.toLocaleString('en-US').substring(1) + ')'
      );
    } else {
      return parseFloat(value)?.toLocaleString('en-US');
    }
  }
};
// .toLocaleString('en-US', { minimumFractionDigits: 4 })

const getHeader = (currentPage, pageCount, data) => {
  const {
    quarter,
    rebateProgramName,
    prinDate,
    requestedBy,
    reportName,
    providerId,
    providerIdName,
    providerEligibilty,
  } = data;
  const header = {
    alignment: 'center',
    fontSize: 10,
    margin: [28.8, 20, 28.8, 25.92],
    style: 'tableExample',
    table: {
      widths: [310, 310, 310],
      body: [
        [
          {
            text: [{ text: 'Requested By: ', bold: true }, requestedBy],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: reportName,
            fontSize: 12,
            bold: true,
            fontFamily: 'arial',
            alignment: 'center',
          },
          {
            text: [{ text: `Date Printed: `, bold: true }, prinDate],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
        [
          {
            text: [{ text: 'Provider Id: ', bold: true }, providerId],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: rebateProgramName,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'center',
            bold: true,
          },
          {
            text: `Page ${currentPage} of ${pageCount}`,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
        [
          {
            text: [{ text: 'Provider Id: ', bold: true }, providerIdName],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: [
              { text: 'Provider Eligibility: ', bold: true },
              providerEligibilty,
            ],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'center',
            bold: true,
          },
          {
            text: [{ text: 'Quarter: ', bold: true }, quarter],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
      ],
    },
    layout: 'noBorders',
  };
  return header;
};

const getHeaderColumns = (columns, type) => {
  let headers =
    type === 'sub'
      ? [
          {
            text: '',
            fontSize: contentFont,
            alignment: 'center',
            color: 'black',
            bold: true,
            border: [true, true, true, true],
          },
        ]
      : [];

  for (let i = 0; i < columns.length; i++) {
    headers.push({
      text: columns[i],
      fontSize: contentFont,
      alignment: 'center',
      color: 'black',
      bold: true,
      border: [true, true, true, true],
    });
  }
  if (type === 'sub') {
    headers.push({
      text: '',
      fontSize: contentFont,
      alignment: 'center',
      color: 'black',
      bold: true,

      border: [true, true, true, true],
    });
    headers.push({
      text: '',
      fontSize: contentFont,
      alignment: 'center',
      color: 'black',
      bold: true,
      border: [true, true, true, true],
    });
  }

  return headers;
};

const getTableRows = (
  providerListData,
  providerListTableHead,
  claimListData,
  providerClaimTableHead
) => {
  const groupedData = groupBy(claimListData, 'drugSeqNum');
  const mainTableHeader = providerListTableHead.map((item) => item.headerName);
  const subTableHeader = providerClaimTableHead.map((item) => item.headerName);
  const border = [true, true, true, true];
  let dataToReturn = [];

  for (let i = 0; i < providerListData.length; i++) {
    const mainHeaders = getHeaderColumns(mainTableHeader, 'main');
    dataToReturn.push(mainHeaders);
    const {
      ndc,
      drugName,
      numOfClaims,
      totalBilled,
      totalPaid,
      totalCalculated,
      totalCalculatedPaid,
      totalRebate,
      ura,
      units,
      drugSeqNum,
    } = providerListData[i];
    const RedColor='#a81f00'

    dataToReturn.push([
      {
        text: ndc,
        fontSize: contentFont - 1,
        alignment: 'center',
        color: 'black',
        border,
      },
      {
        text: drugName,
        fontSize: contentFont - 1,
        alignment: 'center',
        color: 'black',
        border,
      },
      {
        text: numOfClaims,
        fontSize: contentFont - 1,
        alignment: 'right',
        color: 'black',
        border,
      },
      {
        text: valueFormatter(totalBilled),
        fontSize: contentFont - 1,
        alignment: 'right',
        color: totalBilled < 0 ? RedColor : 'black',
        border,
      },
      {
        text: valueFormatter(totalPaid),
        fontSize: contentFont - 1,
        alignment: 'right',
        color: totalPaid < 0 ? RedColor : 'black',
        border,
      },
      {
        text: valueFormatter(totalCalculated),
        fontSize: contentFont - 1,
        alignment: 'right',
        color: totalCalculated < 0 ? RedColor : 'black',
        border,
      },
      {
        text: valueFormatter(totalCalculatedPaid),
        fontSize: contentFont - 1,
        alignment: 'right',
        color: totalCalculatedPaid < 0 ? RedColor : 'black',
        border,
      },
      {
        text: valueFormatter(totalRebate),
        fontSize: contentFont - 1,
        alignment: 'right',
        color: totalRebate < 0 ? RedColor : 'black',
        border,
      },
      {
        text: numberFormatter(ura),
        fontSize: contentFont - 1,
        alignment: 'right',
        color: ura < 0 ? RedColor : 'black',
        border,
      },
      {
        text: numberFormatter(units),
        fontSize: contentFont - 1,
        alignment: 'right',
        color: units < 0 ? RedColor : 'black',
        border,
      },
    ]);
    const claimData = groupedData[drugSeqNum] || [];

    const subHeaders = getHeaderColumns(subTableHeader, 'sub');

    dataToReturn.push(subHeaders);
    for (let j = 0; j < claimData.length; j += 1) {
      const {
        claimId,
        billed,
        paid,
        calculated,
        calculatedPaid,
        rebate,
        units,
      } = claimData[j];

      dataToReturn.push([
        {
          text: '',
          fontSize: contentFont,
          alignment: 'center',
          color: 'black',
          border,
        },
        {
          text: claimId,
          fontSize: contentFont,
          alignment: 'center',
          color: 'black',
          border,
        },
        {
          text: valueFormatter(billed),
          fontSize: contentFont,
          alignment: 'right',
          color: billed < 0 ? 'red' : 'black',
          border,
        },
        {
          text: valueFormatter(paid),
          fontSize: contentFont,
          alignment: 'right',
          color: paid < 0 ? 'red' : 'black',
          border,
        },
        {
          text: valueFormatter(calculated),
          fontSize: contentFont,
          alignment: 'right',
          color: calculated < 0 ? 'red' : 'black',
          border,
        },
        {
          text: valueFormatter(calculatedPaid),
          fontSize: contentFont,
          alignment: 'right',
          color: calculatedPaid < 0 ? 'red' : 'black',
          border,
        },
        {
          text: valueFormatter(rebate),
          fontSize: contentFont,
          alignment: 'right',
          color: rebate < 0 ? 'red' : 'black',
          border,
        },
        {
          text: numberFormatter(units, true),
          fontSize: contentFont,
          alignment: 'right',
          color: units < 0 ? 'red' : 'black',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'center',
          color: 'black',
          border,
        },
        {
          text: '',
          fontSize: contentFont,
          alignment: 'center',
          color: 'black',
          border,
        },
      ]);
    }

    let blankRow = [];
    for (let k = 0; k < 9; k++) {
      blankRow.push({
        text: '',

        pageBreak: 'after',
        border: [false, false, false, false],
      });
    }

    blankRow.push({
      text: '',
      pageBreak: 'after',
      border: [false, false, false, false],
    });
    if (i < providerListData.length - 1) {
      // dataToReturn.push(blankRow);
    }
  }
  return dataToReturn;
};
const getTableBody = (
  providerListData,
  providerListTableHead,
  claimListData,
  providerClaimTableHead,
  selectedProvider
) => {
  let providerData = providerListData;
  if (selectedProvider.length > 0) {
    providerData =
      providerListData.filter(
        (item) => item.drugSeqNum === selectedProvider[0].drugSeqNum
      ) || [];
  }
  return [
    {
      style: 'tableExample',
      color: '#444',
      table: {
        widths: [70, 165, 70, 70, 70, 100, 100, 70, 70, 70],
        body: [
          ...getTableRows(
            providerData,
            providerListTableHead,
            claimListData,
            providerClaimTableHead
          ),
        ],
      },
    },
  ];
};
const getPdfData = (
  providerListData,
  providerListTableHead,
  claimListData,
  providerClaimTableHead,
  data,
  selectedProvider
) => {
  const content = getTableBody(
    providerListData,
    providerListTableHead,
    claimListData,
    providerClaimTableHead,
    selectedProvider
  );
  return {
    header: (currentPage, pageCount) => {
      return getHeader(currentPage, pageCount, data);
    },
    content,
    pageMargins,
    styles,
    pageOrientation: 'landscape',
    pageSize: {
      width: 1020,
      height: 700,
    },
  };
};

const providerClaimDetailsPDF = (
  providerListData,
  providerListTableHead,
  claimListData,
  providerClaimTableHead,
  userDefaults,
  getRebateProgramName,
  getQuarter,
  providerIdValue,

  fileName,
  providerIdype,
  name,
  providerSelectionValue,
  selectedProvider,
  logInUser,
  dispatch
) => {
  const data = {
    requestedBy:
      userDefaults && userDefaults.userId ? userDefaults.userId : logInUser,
    prinDate: moment(new Date()).format('MM/DD/YYYY'),
    reportName: 'Provider Claim Listing Report',
    rebateProgramName: getRebateProgramName.name.replace('|', '-'),
    quarter: getQuarter,
    providerId: providerIdype,
    providerIdName: name,
    providerEligibilty: providerSelectionValue,
  };
  const pdfData = getPdfData(
    providerListData,
    providerListTableHead,
    claimListData,
    providerClaimTableHead,
    data,
    selectedProvider
  );
  pdfMake.createPdf(pdfData).download(`${fileName}.pdf`);
  dispatch(dispatchTableLoader(false));
};

export default providerClaimDetailsPDF;
